<template>
    <div class="goods">
        <div class="header-text">
            <div class="iconfont icon-xinpin title"><span>{{cartInfo.mer_name}}</span></div>
            <span class="count">共{{ cartInfo.length }}件商品</span>
        </div>
        <div class="goodWrapper">
            <div class="item acea-row row-between-wrapper" v-for="cart in cartInfo" :key="cart.id">
                <div class="pictrue">
                    <img :src="cart.productInfo.image" class="image" />
                </div>
                <div class="text">
                    <div class="acea-row row-between-wrapper">
                        <div class="name line1">{{ cart.productInfo.store_name }}</div>
                        <div class="num">x {{ cart.cart_num }}</div>
                    </div>
                    <div class="attr line1" v-if="cart.productInfo.attrInfo">
                        {{ cart.productInfo.attrInfo.suk }}
                    </div>
                    <div class="money font-color-red" v-if="is_score == 1">{{ cart.truePrice }}积分</div>
                    <div class="money font-color-red" v-else>￥{{ cart.truePrice }}</div>
                    <div class="evaluate" v-if="evaluate === 3"
                        @click="$router.push({ path: '/goods_evaluate/' + cart.unique })">
                        评价
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: "Goods",
        props: {
            evaluate: Number,
            cartInfo: {
                type: Array,
                default: () => []
            },
            is_score: Number
        },
        data: function () {
            return {};
        },
        mounted: function () {},
        methods: {}
    };
</script>
